module.exports = __webpack_public_path__ + "static/media/reg7.2e4d1fba.jpg";